import script from "./FooterCopyright.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&setup=true&lang=js"

import "./FooterCopyright.vue?vue&type=style&index=0&id=01c81576&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c81576"]])

export default __exports__